import { render } from "./TableSkeleton.vue?vue&type=template&id=1843d495&ts=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=ts"
export * from "./TableSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__